import React, { memo, ReactElement } from 'react'

import * as Styled from './Title.styled'

type Props = {
  text: string
  icon?: string
}

function Title({ text, icon }: Props): ReactElement {
  return (
    <Styled.Wrapper>
      <Styled.Title>
        {text}
        {icon && <Styled.Img width="34" height="34" src={icon} alt={icon} />}
      </Styled.Title>
    </Styled.Wrapper>
  )
}

export default memo(Title)
